var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fit-viewport"},[_c('div',{ref:"pad",staticClass:"pad"},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }